/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Calendar_Events_ErrorInputs */

const es_tools_calendar_events_error = /** @type {(inputs: Tools_Calendar_Events_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al obtener eventos de Google`)
};

const en_tools_calendar_events_error = /** @type {(inputs: Tools_Calendar_Events_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error fetching Google events`)
};

/**
* | output |
* | --- |
* | "Error fetching Google events" |
*
* @param {Tools_Calendar_Events_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_calendar_events_error = /** @type {((inputs?: Tools_Calendar_Events_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Calendar_Events_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_calendar_events_error(inputs)
	return en_tools_calendar_events_error(inputs)
});
export { tools_calendar_events_error as "tools.calendar.events_error" }